import { notification as dispatchNotification } from "antd"

let timeout: NodeJS.Timeout
export const toast = (message: string, type: "success" | "info" | "warning" | "error", description?: string, options?: Record<string, unknown>): void => {
	if (timeout) clearTimeout(timeout)
	timeout = setTimeout(() => {
		// dispatchNotification.destroy()
		dispatchNotification[type]({ message, description, ...options })
	}, 100)
}

toast.success = (message: string, description: string, options?: any) => toast(message, "success", description, options)

toast.info = (message: string, description: string, options?: any) => toast(message, "info", description, options)

toast.warn = (message: string, description: string, options?: any) => toast(message, "warning", description, options)

toast.error = (message: string, description: string, options?: any) => toast(message, "error", description, options)
